export default "__VITE_ASSET__BsDJl96Q__"